import { Box, Flex, useDisclosure } from '@chakra-ui/react';
import { Outlet, useLocation } from 'react-router-dom'
import { MobileTopBar } from './MobileTopBar'
import { ContextualTabBar } from './ContextualTabBar'
import { ModulesSheet } from './ModulesSheet'
import type { SidebarContextType } from '../DashboardLayout'
import { isImmersiveRoute } from '../immersive'

export function MobileDashboardShell() {
  const location = useLocation()
  const modules = useDisclosure()

  // Mobile has no sidebar; provide a stub so pages calling useSidebarContext() work.
  const stubSidebar: SidebarContextType = { collapsed: true, setCollapsed: () => {} }

  // A6 slice 3b: immersive routes (the turf cutter) own the full viewport — no
  // top bar, committee switcher, tab bar, or bottom tab-bar padding. bg="canvas"
  // is the semantic surface; the normal branch's legacy gray.50 is slice-6's migration.
  if (isImmersiveRoute(location.pathname)) {
    return (
      <Flex direction="column" minH="100dvh" bg="canvas">
        <Outlet context={stubSidebar} />
      </Flex>
    )
  }

  return (
    <Flex direction="column" minH="100vh" bg="gray.50">
      <MobileTopBar pathname={location.pathname} />
      <Box flex={1} overflowY="auto" pb="calc(72px + env(safe-area-inset-bottom, 0px))">
        <Outlet context={stubSidebar} />
      </Box>
      <ContextualTabBar pathname={location.pathname} onOpenModules={modules.onOpen} />
      <ModulesSheet isOpen={modules.open} onClose={modules.onClose} />
    </Flex>
  );
}
